import React, { useContext, useEffect, useRef, useState } from "react"
import InboxLeftMenu from "./InboxLeftMenu"
import { connect, useSelector } from "react-redux"
import { LineWave } from "react-loader-spinner"
import {
  getInboxChatUsers,
  getInboxMessages,
  getMessageLikes,
  inboxDisconnect,
  initInboxSession,
  saveCommentBoardDialogs,
  saveDirectMessageDialogs,
  saveNewInboxMessage,
  saveNewsFeedDialogs,
} from "store/actions"
import { LoadingIndicator } from "components/LoadingIndicator"
import DialogsList from "./dialogsList"
import InboxChatBox from "./inboxChatBox"
import { disconnect } from "services/quickblox"
import { sortDialogsByDate } from "./utils"
import CreateDialog from "./CreateDialog"
import DialogIdetails from "./DialogIdetails"
import "../../assets/scss/custom/inbox/Header.scss"
import { DialogProvider } from "./helperHooks/HelperContext"
import PageMetaTags from "components/PageMetaTags"
import SocialProfile from "./SocialProfile"
const Index = ({
  initInboxSession,
  chatCred,
  inboxSessionIsLoading,
  commentBoardDialogs,
  directMessageDialogs,
  newsFeedDialogs,
  getInboxMessages,
  qbConnected,
  inboxDisconnect,
  messageListIsLoading,
  chatUsers,
  getInboxChatUsers,
  saveCommentBoardDialogs,
  saveNewsFeedDialogs,
  saveDirectMessageDialogs,
  saveNewInboxMessage,
  getMessageLikes,
  messages,
}) => {
  const selections = {
    ALL_INBOX: 0,
    COMMENT_BOARDS: 1,
    DIRECT_MESSAGES: 2,
    NEWS_FEEDS: 3,
  }

  const [activeSection, setActiveSection] = useState(selections?.ALL_INBOX)
  const [clientConfigData, setClientConfig] = useState(() => {
    const storedData = localStorage.getItem("ngStorage-client-config")
    return storedData ? JSON.parse(storedData) : null
  })

  const [selectedChat, setSelectedChat] = useState(null)
  const selectedChatRef = useRef(null)
  const [allDialogs, setAllDialogs] = useState([])
  const [createDialogModal, setCreateDialogModal] = useState({ type: null, visible: null });
  const [dialogIdetailsArea, setDialogIdetailsArea] = useState(false)
  const directMessageDialog = useSelector(state => state.Inbox.directMessageDialogs);

  useEffect(() => {
    return () => {
      disconnect(inboxDisconnect)
    }
  }, [])

  useEffect(() => {
    if (chatCred && !qbConnected) {
      initInboxSession({
        login: chatCred?.name,
        password: chatCred?.password,
        onMessageListener,
      })
    }
  }, [chatCred])
  useEffect(() => {
    if (!qbConnected) return;

    setAllDialogs(prevDialogs => {
      const combined = [
        ...(commentBoardDialogs?.items || []),
        ...(directMessageDialog?.items || []),
        ...(clientConfigData?.news_feed_enabled ? newsFeedDialogs?.items || [] : []),
      ];

      const updatedIds = combined.map(d => d._id).sort().join(",");
      const prevIds = prevDialogs.map(d => d._id).sort().join(",");

      if (updatedIds === prevIds) {
        return prevDialogs;
      }

      // Preserve currently selected chat at top (only for ALL_INBOX)
      let sortedDialogs = combined.sort(sortDialogsByDate);
      if (activeSection === selections.ALL_INBOX && selectedChat?._id) {
        const existing = sortedDialogs.find(d => d._id === selectedChat._id);
        if (existing) {
          sortedDialogs = [existing, ...sortedDialogs.filter(d => d._id !== selectedChat._id)];
        }
      }

      return sortedDialogs;
    });
  }, [qbConnected, commentBoardDialogs, directMessageDialog, newsFeedDialogs, activeSection, selectedChat]);


  useEffect(() => {
    if (!!selectedChat && qbConnected) {
      getInboxMessages({ dialog: selectedChat })
      selectedChatRef.current = selectedChat
      if (selectedChat?.feature_type === 3) {
        getMessageLikes({ dialog_qb_id: selectedChat?._id })
      }
    }
  }, [selectedChat])

  useEffect(() => {
    if (qbConnected && allDialogs?.length > 0) {
      switch (activeSection) {
        case selections.ALL_INBOX:
          setSelectedChat(allDialogs[0])
          return
        case selections.COMMENT_BOARDS:
          setSelectedChat(commentBoardDialogs?.items[0])
          return
        case selections.DIRECT_MESSAGES:
          setSelectedChat(directMessageDialogs?.items[0])
          return
        case selections.NEWS_FEEDS:
          setSelectedChat(newsFeedDialogs?.items[0])
          return
      }
    }
  }, [qbConnected, activeSection])

  const onMessageListener = (
    userId,
    message,
    { directMessageDialogs, commentBoardDialogs, newsFeedDialogs }
  ) => {
    const selectedChat = selectedChatRef.current;
    let updatedDialog = null;

    //  Save message to current chat window if it matches
    if (
      selectedChat &&
      (message?.dialog_id === selectedChat?._id ||
        message?.dialog_id === selectedChat?.xmpp_room_jid) &&
      userId !== chatCred?.qb_id
    ) {
      saveNewInboxMessage({
        _id: message.id,
        attachments: message.extension.attachments || [],
        date_sent: +message.extension.date_sent * 1000,
        message: message.body,
        sender_id: userId,
        created_at: +message.extension.date_sent * 1000,
      });
    }

    // Handle Comment Board
    const cbIndex = commentBoardDialogs?.items?.findIndex(
      x => x._id === message?.dialog_id || message?.dialog_id === x?.xmpp_room_jid
    );
    if (cbIndex > -1) {
      const dialogs = [...commentBoardDialogs.items];
      updatedDialog = {
        ...dialogs[cbIndex],
        last_message: message.body,
        last_message_date_sent: message.extension.date_sent,
        last_message_id: message.extension.message_id,
      };
      dialogs.splice(cbIndex, 1);
      dialogs.unshift(updatedDialog);
      saveCommentBoardDialogs({ ...commentBoardDialogs, items: dialogs });
    }

    //  Handle Direct Messages
    const dmIndex = directMessageDialogs?.items?.findIndex(
      x => x._id === message?.dialog_id || message?.dialog_id === x?.xmpp_room_jid
    );
    if (dmIndex > -1) {
      const dialogs = [...directMessageDialogs.items];
      updatedDialog = {
        ...dialogs[dmIndex],
        last_message: message.body,
        last_message_date_sent: message.extension.date_sent,
        last_message_id: message.extension.message_id,
        unread_messages_count:
          chatCred?.qb_id === userId ||
            (selectedChat &&
              (message?.dialog_id === selectedChat?._id ||
                message?.dialog_id === selectedChat?.xmpp_room_jid))
            ? dialogs[dmIndex].unread_messages_count
            : dialogs[dmIndex].unread_messages_count + 1,
      };
      dialogs.splice(dmIndex, 1);
      dialogs.unshift(updatedDialog);
      saveDirectMessageDialogs({
        ...directMessageDialogs,
        items: dialogs,
        unreadCount:
          chatCred?.qb_id === userId ||
            (selectedChat &&
              (message?.dialog_id === selectedChat?._id ||
                message?.dialog_id === selectedChat?.xmpp_room_jid))
            ? directMessageDialogs.unreadCount
            : directMessageDialogs.unreadCount + 1,
      });
    }

    // Handle News Feed
    const nfIndex = newsFeedDialogs?.items?.findIndex(
      x => x._id === message?.dialog_id || message?.dialog_id === x?.xmpp_room_jid
    );
    if (nfIndex > -1) {
      const dialogs = [...newsFeedDialogs.items];
      updatedDialog = {
        ...dialogs[nfIndex],
        last_message: message.body,
        last_message_date_sent: message.extension.date_sent,
        last_message_id: message.extension.message_id,
      };
      dialogs.splice(nfIndex, 1);
      dialogs.unshift(updatedDialog);
      saveNewsFeedDialogs({ ...newsFeedDialogs, items: dialogs });
    }

    // Immediately update allDialogs if the user - in All Inbox
    if (activeSection === selections.ALL_INBOX && updatedDialog) {
      setAllDialogs(prevDialogs => {
        const filtered = prevDialogs.filter(d => d._id !== updatedDialog._id);
        return [updatedDialog, ...filtered].sort(sortDialogsByDate);
      });
    }
  };


  const handleInboxSelector = params => {
    if (activeSection == params) return 0
    setActiveSection(params)
  }

  const renderDialogList = () => {
    switch (activeSection) {
      case selections?.COMMENT_BOARDS:
        return (
          <DialogsList
            dialogs={commentBoardDialogs?.items}
            handleDialogSelect={dialog => setSelectedChat(dialog)}
            selectedDialog={selectedChat}
          />
        )
      case selections?.ALL_INBOX:
        return (
          <DialogsList
            dialogs={allDialogs}
            handleDialogSelect={dialog => setSelectedChat(dialog)}
            selectedDialog={selectedChat}
            allDialogs={true}
          />
        )
      case selections?.DIRECT_MESSAGES:
        return (
          <DialogsList
            dialogs={directMessageDialogs?.items}
            handleDialogSelect={dialog => setSelectedChat(dialog)}
            selectedDialog={selectedChat}
          />
        )
      case selections?.NEWS_FEEDS:
        return (
          <DialogsList
            dialogs={newsFeedDialogs?.items}
            handleDialogSelect={dialog => setSelectedChat(dialog)}
            selectedDialog={selectedChat}
          />
        )
      default:
        return null
    }
  }
  return (
    <React.Fragment>
      <DialogProvider
        createDialogModal={createDialogModal}
        setCreateDialogModal={setCreateDialogModal}
        allDialogs={allDialogs}
        setAllDialogs={setAllDialogs}
        directMessageDialogs={directMessageDialogs}
        dialogIdetailsArea={dialogIdetailsArea}
        setDialogIdetailsArea={setDialogIdetailsArea}
        selectedChat={selectedChat}
        setSelectedChat={setSelectedChat}
        activeSection={activeSection}
      >

        <div className="page-content">
          <PageMetaTags title="Inbox" />
          {createDialogModal?.visible && <CreateDialog />}
          {inboxSessionIsLoading ? (
            <LoadingIndicator />
          ) : (
            <section className="inbox-wrapper">
              <div className="inbox-left">
                <InboxLeftMenu
                  {...{
                    activeSection,
                    selections,
                    handleInboxSelector,
                  }}
                  unreadMessages={directMessageDialogs?.unreadCount}
                  isNewsFeedEnabled={clientConfigData?.news_feed_enabled}
                />
              </div>
              <div className="inbox-right-wrapper">
                <div className="comments-details">
                  <div className="comments-header">
                    <div className="dialog-list-header">

                      <div className="dialog-header">
                        <div className="dialog-header__body">
                          <div className="dialog-header__body-left">
                            <span className="dialog-header__title">
                              {activeSection == 0
                                ? "All Inboxes"
                                : activeSection == 1
                                  ? "Comment Boards"
                                  : activeSection == 2
                                    ? "Direct Messages"
                                    : activeSection == 3
                                      ? "News Feeds"
                                      : "All Video Calls"}
                            </span>
                          </div>

                          <div className="dialog-header__body-right" style={activeSection === 0 || activeSection === 2 ? {} : { opacity: 0.4, pointerEvents: 'none' }}>
                            {/* search icon */}
                            {/* <span className="dialog-header__icon">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" className="dialog-list-header__icons">
                                <path d="M28.884 26.134h-1.448l-.514-.495a11.86 11.86 0 0 0 2.879-7.755c0-6.581-5.335-11.916-11.917-11.916S5.968 11.303 5.968 17.884s5.335 11.917 11.916 11.917c2.952 0 5.665-1.082 7.755-2.878l.495.513v1.448l9.167 9.148 2.731-2.731zm-11 0a8.24 8.24 0 0 1-8.25-8.25 8.24 8.24 0 0 1 8.25-8.25 8.24 8.24 0 0 1 8.25 8.25 8.24 8.24 0 0 1-8.25 8.25" />
                              </svg>
                            </span> */}
                            <span className="dialog-header__icon" title="Start a new conversation" onClick={() => { setCreateDialogModal({ type: 1, visible: true }) }}>
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" className="dialog-list-header__icons">
                                <path d="M40.333 7.333a3.677 3.677 0 0 0-3.666-3.666H7.333a3.677 3.677 0 0 0-3.666 3.666v22A3.677 3.677 0 0 0 7.333 33H33l7.333 7.333zm-3.666 24.145-2.145-2.145H7.333v-22h29.334zM23.833 9.167h-3.666V16.5h-7.334v3.667h7.334V27.5h3.666v-7.333h7.334V16.5h-7.334z" />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="search-bar">
                    <input
                      type="text"
                      placeholder="Search"
                      onChange={handleSearch}
                    />
                  </div> */}
                  {renderDialogList()}
                </div>
                <div className="inbox-right">
                  {messageListIsLoading ? (
                    <div className="inbox-loader">
                      <LineWave
                        visible={true}
                        height="200"
                        width="200"
                        color="#091a70"
                        ariaLabel="line-wave-loading"
                        wrapperStyle={{}}
                        wrapperClass="w-100 h-100 d-flex justify-content-center align-items-center"
                        firstLineColor=""
                        middleLineColor=""
                        lastLineColor=""
                      />
                    </div>
                  ) : (
                    !!selectedChat &&
                    !!messages && (
                      <InboxChatBox
                        selectedChat={selectedChat}
                        getInboxChatUsers={getInboxChatUsers}
                        chatUsers={chatUsers}

                      />
                    )
                  )}

                </div>
                {selectedChat?.type === 2 && <DialogIdetails selectedChat={selectedChat} setDialogIdetailsArea={setDialogIdetailsArea} />}
                {selectedChat?.type === 3 && <SocialProfile />}
              </div>
            </section>
          )}
        </div>
      </DialogProvider>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  chatCred: state.Login.authUser.chat_credentials,
  userName: state.Login.authUser.display_name,
  commentBoardDialogs: state.Inbox.commentBoardDialogs,
  directMessageDialogs: state.Inbox.directMessageDialogs,
  newsFeedDialogs: state.Inbox.newsFeedDialogs,
  inboxSessionIsLoading: state.Inbox.inboxSessionIsLoading,
  qbConnected: state.Inbox.qbConnected,
  messages: state.Inbox.messages,
  messageListIsLoading: state.Inbox.messageListIsLoading,
  inboxSession: state.Inbox.inboxSession,
  chatUsers: state.Inbox.chatUsers,
})

const mapDispatchToProps = dispatch => ({
  initInboxSession: values => dispatch(initInboxSession(values)),
  getInboxMessages: values => dispatch(getInboxMessages(values)),
  inboxDisconnect: () => dispatch(inboxDisconnect()),
  getInboxChatUsers: values => dispatch(getInboxChatUsers(values)),
  saveCommentBoardDialogs: values => dispatch(saveCommentBoardDialogs(values)),
  saveNewsFeedDialogs: values => dispatch(saveNewsFeedDialogs(values)),
  saveDirectMessageDialogs: values =>
    dispatch(saveDirectMessageDialogs(values)),
  saveNewInboxMessage: values => dispatch(saveNewInboxMessage(values)),
  getMessageLikes: values => dispatch(getMessageLikes(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Index)
